/**
 * @file _template.js
 */
'use strict';

/**
 * @classname Template
 */

export default class Template {


	/**
	 * 履歴書エリア(職種)
	 *
	 * @memberof Template
	 * @param {number} prAreaNum - 履歴書エリア数
	 * @return {string} - 部署
	 */
	static addPrArea_occupation(prAreaNo) {
		console.log('Template.addPrArea_occupation');
		const index = prAreaNo -1;
		let prArea = `
		<div class="mt10 form-group" data-no="${prAreaNo}">
		<h4 class="heading heading--form-inner-title">職歴${prAreaNo}</h4>
		<div class="form-group-content">
			<div class="form-label">勤務先名<span class="badge badge--required">必須</span></div>
			<div class="form-group-content-inner form-group-content-inner--office_name"><input class="office_name0${prAreaNo} validate input-text" id="office_name0${prAreaNo}" name="office_name0${prAreaNo}" placeholder="株式会社アルファスタッフ" data-validate="empty" value="" type="text">
				<p class="error-tip"><span class="error-tip-inner"></span></p>
			</div>
		</div>
		<div class="form-group-content">
			<div class="form-label">業種<span class="badge badge--required">必須</span></div>
			<div class="form-group-content-inner form-group-content-inner--industry">
				<div class="input-select"><select class="industry0${prAreaNo}_id validate input-select-select" id="industry0${prAreaNo}_id" name="industry0${prAreaNo}_id" data-validate="empty">
						<option class="placeholder" value="">選択してください</option>
						<option value="1">ホテル・旅館</option>
						<option value="2">飲食業</option>
						<option value="3">小売業（スーパー・コンビニ・量販店・百貨店・etc）</option>
						<option value="4">製造業（メーカー）</option>
						<option value="5">レジャー・旅行</option>
						<option value="6">情報・通信</option>
						<option value="7">美容・エステ</option>
						<option value="8">金融・保健</option>
						<option value="9">住宅・建築・不動産</option>
						<option value="10">マスコミ（広告・出版・etc）</option>
						<option value="11">人材サービス</option>
						<option value="12">学校・教育関連</option>
						<option value="13">医療・介護・福祉</option>
						<option value="14">運輸・輸送</option>
						<option value="15">商社</option>
						<option value="16">その他</option>
						<option value="17">なし</option>
					</select></div>
				<p class="error-tip"><span class="error-tip-inner"></span></p>
			</div>
		</div>
		<div class="form-group-content">
			<div class="form-label">雇用形態<span class="badge badge--required">必須</span></div>
			<div class="form-group-content-inner form-group-content-inner--employment_type">
				<div class="input-select"><select class="employment_type0${prAreaNo}_id validate input-select-select" id="employment_type0${prAreaNo}_id" name="employment_type0${prAreaNo}_id" data-validate="empty">
						<option class="placeholder" value="">選択してください</option>
						<option value="1">正社員</option>
						<option value="2">契約社員</option>
						<option value="3">派遣社員</option>
						<option value="4">パート・アルバイト</option>
						<option value="5">自営業</option>
						<option value="6">公務員</option>
						<option value="7">その他</option>
						<option value="8">なし</option>
					</select></div>
				<p class="error-tip"><span class="error-tip-inner"></span></p>
			</div>
		</div>
		<div class="form-group-content">
			<div class="form-label">職種・仕事内容<span class="badge badge--required">必須</span></div>
			<div class="form-group-content-inner form-group-content-inner--occupation"><input class="occupation0${prAreaNo} validate input-text" id="occupation0${prAreaNo}" name="occupation0${prAreaNo}" placeholder="営業、事務" data-validate="empty" value="" type="text">
				<p class="error-tip"><span class="error-tip-inner"></span></p>
			</div>
		</div>
		<div class="form-group-content">
			<div class="form-label">勤務期間<span class="badge badge--required">必須</span></div>
			<div class="form-group-content-inner form-group-content-inner--period"><input class="period0${prAreaNo} validate input-text" id="period0${prAreaNo}" name="period0${prAreaNo}" placeholder="1年6ヶ月" data-validate="empty" value="" type="text">
				<p class="error-tip"><span class="error-tip-inner"></span></p>
			</div>
		</div>
		<div class="btn-box"><a class="btn btn--main_s remove btn--remove-resume-area">
				<p class="text">職歴エリアを削除する</p>
			</a><a class="btn btn--main_s add btn--add-resume-area">
				<p class="text">職歴エリアを追加する</p>
			</a></div>
	</div>
</div>
`;
// 		if(parseInt(prAreaNo) !== 3){
// 			prArea += `
// 				<a class="mt-4 btn btn-primary btn-add-pr-area mr-4" href="javascript:void(0);">
// 					<i class="fas fa-plus mr-2"></i>PR入力エリアを追加する
// 				</a>
// `;
// 		}else{
// 			prArea += `
// 				<a class="mt-4 btn btn-primary btn-add-pr-area mr-4" href="javascript:void(0);" style="display:none;">
// 					<i class="fas fa-plus mr-2"></i>PR入力エリアを追加する
// 				</a>
// `;
// 		}
// 		prArea += `
// 				<a class="mt-4 btn btn-danger btn-delete-pr-area" href="javascript:void(0);">
// 					<i class="fas fa-minus mr-2"></i>PR入力エリアを削除する
// 				</a>
// 			</div>
// 		</div>
// 	</div>
// </div>
// `;
		return prArea;
	};

	/**
	 * 履歴書エリア(資格)
	 *
	 * @memberof Template
	 * @param {number} prAreaNum - 履歴書エリア数
	 * @return {string} - 部署
	 */
	 static addPrArea_qualification(prAreaNo) {
		console.log('Template.addPrArea_qualification');
		const index = prAreaNo -1;
		let prArea = `
		<div class="mt10 form-group" data-no="${prAreaNo}">
		<h4 class="heading heading--form-inner-title">資格${prAreaNo}</h4>
		<div class="form-group-content">
			<div class="form-label">資格名<span class="badge badge--optional">任意</span></div>
				<div class="form-group-content-inner form-group-content-inner--qualification"><input class="qualification0${prAreaNo} validate input-text" id="qualification0${prAreaNo}" name="qualification0${prAreaNo}" placeholder="普通自動車免許" data-validate="" value="" type="text">
				<p class="error-tip"><span class="error-tip-inner"></span></p>
			</div>
		</div>
		<div class="form-group-content">
			<div class="form-label">資格取得年<span class="badge badge--optional">任意</span></div>
			<div class="form-flex">
				<div class="form-group-content-inner form-group-content-inner--year_of_qualification">
					<div class="input-box"><input class="year_of_qualification0${prAreaNo} validate input-text" id="year_of_qualification0${prAreaNo}" name="year_of_qualification0${prAreaNo}" placeholder="1990" data-validate="number len-4" value="" inputmode="numeric" pattern="d*" type="text">
						<p class="text ml5">年</p>
					</div>
					<p class="error-tip"><span class="error-tip-inner"></span></p>
				</div>
			</div>
		</div>
		<div class="btn-box"><a class="btn btn--main_s remove btn--remove-resume-area">
				<p class="text">資格エリアを削除する</p>
			</a><a class="btn btn--main_s add btn--add-resume-area" data-resume-type="qualification">
				<p class="text">資格エリアを追加する</p>
			</a></div>
	</div>
`;
		return prArea;
	};

}